import { useCallback } from "react";
import type { ClinicalPractitionerEntry } from "src-next/modules/clinical-insights/types/analysisTypes";

export function useGetPractitionerName(practitioner?: ClinicalPractitionerEntry[]) {
  return useCallback(
    (practitionerReference: string) => {
      if (!practitionerReference) return "Não informado";
      const practId = practitionerReference.split("/")[1];
      const pract = practitioner?.find((p) => p.resource?.id === practId);
      const displayName =
        pract?.resource?.name?.[0]?.text ||
        `${pract?.resource?.name?.[0]?.given?.join(" ") || ""} ${
          pract?.resource?.name?.[0]?.family || ""
        }`.trim();
      return displayName || practId || "Não informado";
    },
    [practitioner]
  );
}

export function patientDisplayName(patient?: fhir5.Patient): string {
  if (!patient?.name?.[0]) return "Não informado";
  return (
    patient.name[0].text ||
    `${patient.name[0].given?.join(" ") || ""} ${patient.name[0].family || ""}`.trim() ||
    "Não informado"
  );
}

export function normalizePatientId(patientRef: string): string {
  return patientRef.includes("/") ? patientRef.split("/")[1] : patientRef;
}
